import React, {Component} from "react"
import ErrorImage from '../ErrorImage';

class NotFound extends Component {
    render() {
        return (
            <main>
                <div className="content" id="404notfound">
                    <ErrorImage text="404 Not found" subtext="Deze pagina kunnen we niet vinden"/>
                </div>
            </main>
        )
    }
}

export default NotFound